
ID    = Math.random()
queue = []

window.addEventListener 'message', (e) ->
  callback = e.data == ID && queue.shift()
  callback && callback()

setImmediate = window.setImmediate || (callback) ->
  queue.push callback
  window.postMessage ID, '*'

export default (callback) -> setImmediate callback
